import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../../../utils/Custom/text";
import CommonForm from "../../../../utils/commonComponent/commonForm";
import { CancelButton, SaveAndUpdate } from "../../../../utils/Custom/Button";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";       
import { BASE_URL } from "../../../../global";
import { getPermissions } from "../../../Pages/rbac/hasAccess";
import { validateRequiredFields } from "../../../../utils/commonComponent/errorAlert";

export const masterTypes = [
  { id: 1, name: "Discipline" },
  { id: 2, name: "Employment Type" },
  { id: 3, name: "Req Status" },
  { id: 4, name: "Priority" },
  { id: 5, name: "Pipeline Stage" },
  { id: 6, name: "Stage Status" },
  { id: 7, name: "Interview Mode" },
  { id: 8, name: "Source Channel" },
  { id: 9, name: "Rejection Reason" },
  { id: 10, name: "Offer Status" },
  { id: 11, name: "BGV Status" },
  { id: 12, name: "Employment Pref" },
  { id: 13, name: "Position" },
];

const inputFields = [
  {
    type: "Autocomplete",
    label: "Type *",
    stateKey: "type",
    options: masterTypes,
    valueKey: "id",
    getOptionLabelKey: "name",
  },
  {
    type: "Textarea",
    label: "Value *",
    stateKey: "Value",
  },
];

const EditMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchDetails = async () => {
    try {
      const [record] = await fetchQuery(
        `SELECT * FROM talentAcquisitionMaster WHERE id = ${params.id}`
      );
      setInputStates(record);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.type, label: "Type is required" },
      { value: inputStates.Value, label: "Value is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) return;

    try {
      const url = BASE_URL + `talentAcquisitionMaster`;
      params.id != 0
        ? await axiosWithToken.patch(`${url}/${params.id}`, inputStates)
        : await axiosWithToken.post(url, inputStates);

      toast.success(
        params.id != 0 ? "Master Updated Successfully!" : "Master Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/talent-acquisition/masters"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create Master" : "Update Master"}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-save"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditMaster;
